import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "@/components/site/Logo";

const scrollLinks = [
  { id: "start", label: "Start" },
  { id: "ueber", label: "Über mich" },
  { id: "schwerpunkte", label: "Schwerpunkte" },
  { id: "ablauf", label: "Ablauf" },
  { id: "preise", label: "Preise" },
  { id: "wichtig", label: "Wichtig" },
  { id: "fragen", label: "Fragen" },
  { id: "kontakt", label: "Kontakt" },
];

export default function Navigation() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const onHome = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    if (!onHome) {
      window.location.href = `/#${id}`;
      return;
    }
    if (id === "start") {
      window.__lenis
        ? window.__lenis.scrollTo(0, { duration: 1.2 })
        : window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    if (window.__lenis) {
      window.__lenis.scrollTo(`#${id}`, { offset: -80, duration: 1.2 });
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled || !onHome || open ? "glass-nav" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="flex items-center justify-between h-20">
          <Link to="/" data-testid="nav-brand" aria-label="Witali Albrecht — Startseite" className="group">
            <Logo />
          </Link>

          <nav className="hidden lg:flex items-center gap-6">
            {scrollLinks.map((l) => (
              <button
                key={l.id}
                data-testid={`nav-link-${l.id}`}
                onClick={() => go(l.id)}
                className="text-[13px] text-[#2E1A10]/80 hover:text-[#A8482B] transition-colors"
              >
                {l.label}
              </button>
            ))}
            <button
              data-testid="nav-cta"
              onClick={() => go("kontakt")}
              className="btn-primary rounded-full px-6 py-2.5 text-sm font-medium"
            >
              Erstgespräch
            </button>
          </nav>

          <button
            data-testid="nav-mobile-toggle"
            aria-label="Menü öffnen"
            className="lg:hidden p-2 -mr-2 text-[#2E1A10]"
            onClick={() => setOpen((v) => !v)}
          >
            {open ? <X strokeWidth={1.5} /> : <Menu strokeWidth={1.5} />}
          </button>
        </div>

        {open && (
          <div className="lg:hidden pb-6 pt-2 flex flex-col gap-1 max-h-[70vh] overflow-y-auto bg-[#FCEFE2]/95 backdrop-blur-xl rounded-b-2xl shadow-lg -mx-5 px-5 sm:-mx-8 sm:px-8 lg:-mx-12 lg:px-12">
            {scrollLinks.map((l) => (
              <button
                key={l.id}
                data-testid={`nav-mobile-link-${l.id}`}
                onClick={() => go(l.id)}
                className="text-left text-base text-[#2E1A10]/90 py-2.5 border-b border-[#F7E6D2]"
              >
                {l.label}
              </button>
            ))}
            <button
              data-testid="nav-mobile-cta"
              onClick={() => go("kontakt")}
              className="btn-primary rounded-full px-6 py-3 text-sm font-medium mt-3"
            >
              Kostenloses Erstgespräch
            </button>
          </div>
        )}
      </div>
    </header>
  );
}
